import Api from '@/services/Api'

export const UserApiService = {
  fetch () {
    return Api.getData(`user`)
  },
  update (form) {
    return Api.patchData('user', form)
  },
  fetchAllTickets () {
    return Api.getData('user/tickets')
  },
  fetchTicketsForRound (roundId) {
    return Api.getData(`user/tickets/${roundId}`)
  },
  deleteAvatar () {
    return Api.deleteData('user/avatar')
  },
  uploadAvatar (form) {
    return Api.postData('user/avatar', form)
  }
}
